import { Injectable } from "@angular/core";

import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { IndicatorData } from "../../models/domains/pbm/indicators/indicator-data";
import { BackendUrl } from "../../models/domains/urls/back-end.url";
import { UserRoleMediator } from "../mediators/user-role.mediator";
import { IndicatorDataParser } from "../parsers/pbm/indicator/indicator-data.parser";

@Injectable()
export class IndicatorRepository {
  constructor(
    private remoteGatewayFactory: RemoteGatewayFactory,
    private indicatorDataParser: IndicatorDataParser,
    private userRoleMediator: UserRoleMediator,
  ) {}

  public async getIndicatorTypes(): Promise<string[]> {
    const headers = { "Content-Type": "application/json" };

    try {
      const data = await this.remoteGatewayFactory.createDefaultRemoteGateway().getWithHeaders(new BackendUrl("/api/indicator/types"), headers);
      return await Promise.resolve(JSON.parse(data));
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async getIndicatorDataByType(indicatorType: string, fiscalNumber: Array<string>): Promise<IndicatorData[]> {
    const headers = {
      "Content-Type": "application/json",
      "X-CompanyFiscalNumberRoot-Filter": this.userRoleMediator.getCompanyFiscalNumberRoot(),
    };

    /**
     * Feito fiscalNumber[0] para manter padrão atual de 1 empresa até ser resolvido em reunião
     * 23/12/2021
     * Hitalo Santos
     */
    const body = JSON.stringify({
      Indicator: indicatorType,
      FiscalNumber: fiscalNumber && fiscalNumber.length > 0 ? { Value: fiscalNumber[0] } : null,
    });

    try {
      const data = await this.remoteGatewayFactory.createDefaultRemoteGateway().postWithHeaders(new BackendUrl("/api/indicator"), body, headers);
      return await Promise.resolve(this.indicatorDataParser.parse(data));
    } catch (error) {
      return await Promise.reject(error);
    }
  }
}
